import { Component, OnInit } from '@angular/core';
import { AvancePage } from './avance/avance.page';
import { RevolutionsPage } from './revolutions/revolutions.page';
import { VelocityPage } from './velocity/velocity.page';
import { MarchuelosPage } from './marchuelos/marchuelos.page';

import { FirebaseAnalytics } from '@ionic-native/firebase-analytics/ngx';
import { advertisement, ServiceService } from '../service.service';

@Component({
  selector: 'app-tabs',
  templateUrl: './tabs.page.html',
  styleUrls: ['./tabs.page.scss' , '../../assets/scss/styles.scss'],
})
export class TabsPage implements OnInit {

  anvance = AvancePage;
  revolutions = RevolutionsPage;
  velocity = VelocityPage;
  marchuelos = MarchuelosPage;
  menuArray:Array<any> = new Array();
  showTables:boolean = false;
  isMovil:boolean = false;
  advertisements:advertisement = new advertisement();

  constructor(
    private firebaseAnalytics: FirebaseAnalytics,
    public services: ServiceService,
    ) {
      this.firebaseAnalytics.logEvent;
      this.firebaseAnalytics.setCurrentScreen("Calculadora");
  }

  async ngOnInit() {
    this.isMovil = this.services.isMovil();
    if(!this.isMovil){
      this.advertisements = await this.services.getAdvertisementByScreen(8,1);
      this.advertisements.Displayed = this.advertisements.MediaBasico.slice(0,this.advertisements.Rows);
      this.advertisements.Random = this.services.NumberRandom(this.advertisements.Principal.length);
      this.services.postAdvertisementUser(this.advertisements.getAllRelAdsMetricsIdDisplayed());
    }
  }

  public setUpMenu(){
    this.menuArray.push({
      ruta: '/revo',
      desc: 'FÓRMULAS PARA CENTRO DE MAQUINADO',
      icon: 'assets/images/calculadora/rpm.png'
    });
    this.menuArray.push({
      ruta: '/rpmma',
      desc: 'RECOMENDACIONES DE RPM PARA MACHUELOS',
      icon: 'assets/images/calculadora/machuelos.png'
    });
    this.menuArray.push({
      ruta: '/brocas',
      desc: 'RECOMENDACIONES RPM BROCAS',
      icon: 'assets/images/calculadora/brocas.png'
    });
    this.menuArray.push({
      ruta: '/rpm',
      desc: 'CALCULO RPM PARA CENTRO DE TORNEADO',
      icon: 'assets/images/calculadora/g97.png'
    });
    this.menuArray.push({
      ruta: '/angulos',
      desc: 'DISTANCIAS DE CHAFLANES PARA TORNO',
      icon: 'assets/images/calculadora/angulos.png'
    });
    this.menuArray.push({
      ruta: '/EqvAcabSuperficialesRa',
      desc: 'EQUIVALENCIAS PARA ACABADOS SUPERFICIALES RA',
      icon: '../assets/images/calculadora/rpm.png'
    });
    this.menuArray.push({
      ruta: '/TolerIsoDE',
      desc: 'TOLERANCIA ISO PARA DIAMETRO NOMINAL EXTERIOR',
      icon: '../assets/images/calculadora/rpm.png'
    });
    this.menuArray.push({
      ruta: '/TolerIsoDI',
      desc: 'TOLERANCIA ISO PARA DIAMETRO NOMINAL INTERIOR',
      icon: '../assets/images/calculadora/rpm.png'
    });
    this.menuArray.push({
      ruta: '/RoscAmerEstdTolerP',
      desc: 'ROSCAS AMERICANAS ESTANDARIZADAS, TOLERANCIAS Y PASO',
      icon: './assets/images/calculadora/rpm.png'
    });
    this.menuArray.push({
      ruta: '/TamBrocasFraccMetricoNumAlfa',
      desc: 'TAMAÑO DE BROCAS FRACC, METRICOS, NUM Y ALFABET',
      icon: '../assets/images/calculadora/rpm.png'
    });
    this.menuArray.push({
      ruta: '/BrocasRecomendadasMachuel',
      desc: 'BROCAS RECOMENDADAS PARA MACHUELEAR ROSCAS MILIMETRICAS',
      icon: '../assets/images/calculadora/rpm.png'
    });
    this.menuArray.push({
      ruta: '/BrocasRecmenMachuelearRoscPulg',
      desc: 'BROCAS RECOMENDADAS PARA MACHUELEAR ROSCAS PULGADAS',
      icon: '../assets/images/calculadora/rpm.png'
    });
  }

  public changeMenu(){
    this.showTables = !this.showTables;
  }

}
